import { takeEvery, put } from "redux-saga/effects"
import { getCalendar, getPlanCalendar } from "src/engine/repositories/calendars"
import { requestValidate } from "src/engine/modules/validate/actions/creators"
import { INIT_CALENDAR } from "../actions/types"
import {
  initCalendarStarted,
  initCalendarCompleted,
  initCalendarFailed,
} from "../actions/creators"

function* initCalendar(action) {
  yield put(initCalendarStarted())

  const { query, planId } = action.payload

  try {
    const { data, headers } = planId
      ? yield getPlanCalendar({ ...query, planId })
      : yield getCalendar(query)

    yield put(initCalendarCompleted(data, Number(headers[`total-count`])))
    if (planId) {
      yield put(requestValidate({ plan: planId }))
    }
  } catch (error) {
    yield put(initCalendarFailed())
  }
}

export default function* initCalendarWatcher() {
  yield takeEvery(INIT_CALENDAR, initCalendar)
}
